/* Richtext with image section
 * Authored as a custom element (Web Component).
 * Lazy image: the real source is kept in data-src / data-srcset and only swapped
 * into the <img> on the first user interaction (touch / scroll / pointer / key /
 * wheel), deferring the request until the visitor engages with the page.
 */
if (!customElements.get('richtext-image')) {
  class RichtextImage extends HTMLElement {
    constructor() {
      super();
      this.images = Array.from(this.querySelectorAll('img[data-src]'));
      this.loaded = false;
      this.interactionEvents = ['pointerdown', 'touchstart', 'keydown', 'mousemove', 'wheel', 'scroll'];
      this.handleFirstInteraction = this.handleFirstInteraction.bind(this);
    }

    connectedCallback() {
      if (this.images.length === 0) return;
      this.interactionEvents.forEach((evt) =>
        window.addEventListener(evt, this.handleFirstInteraction, { once: true, passive: true })
      );
    }

    disconnectedCallback() {
      this.interactionEvents.forEach((evt) =>
        window.removeEventListener(evt, this.handleFirstInteraction)
      );
    }

    handleFirstInteraction() {
      if (this.loaded) return;
      this.loaded = true;

      this.images.forEach((img) => {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        if (img.dataset.src) img.src = img.dataset.src;
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-src');
      });

      this.interactionEvents.forEach((evt) =>
        window.removeEventListener(evt, this.handleFirstInteraction)
      );
    }
  }

  customElements.define('richtext-image', RichtextImage);
}
